import { Injectable, OnDestroy } from '@angular/core';
import { SnackbarFacade, SnackbarPersistenceState } from '@main/snackbar/data-access';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SnackbarPersistenceService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    protected statePersistenceService: StatePersistenceService,
    private snackbarFacade: SnackbarFacade,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'snackbar',
        state$: this.getSnackbarPersistenceState(),
        storageType: StorageSyncType.LOCAL_STORAGE,
        onRead: (state) => this.onRead(state),
      }),
    );
  }

  onRead(state: SnackbarPersistenceState): void {
    if (state?.hidden) {
      this.snackbarFacade.hideSnackbar();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getSnackbarPersistenceState(): Observable<SnackbarPersistenceState> {
    return this.snackbarFacade.getSnackbarHidden().pipe(map((hidden: boolean) => ({ hidden })));
  }
}
